export const VideoStatus = {
    Uploading: 'uploading',
    UploadFailed: 'upload-failed',
    Transcoding: 'transcoding',
    TranscodingFailed: 'transcoding-failed',
    Finalizing: 'finalizing',
    Cancelled: 'cancelled',
    Failed: 'failed',
    Ready: 'ready'
  };
  
  export function getVideoStatusViaString(status) {
    for (const enumKey in VideoStatus) {
      if (typeof VideoStatus[enumKey] === 'string') {
        const enumValue = VideoStatus[enumKey];
        if (enumValue === status) {
          return enumValue;
        }
      }
    }
  
    return undefined;
  }
  